/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Notes_OffInputs */



/**
* | output |
* | --- |
* | "Notetaker off" |
*
* @param {Meeting_Notes_OffInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_notes_off = /** @type {((inputs?: Meeting_Notes_OffInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Notes_OffInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Notetaker uit")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Notetaker désactivé")
	return /** @type {LocalizedString} */ ("Notetaker off")
});